/**
 * @description 客户端数据store
 */

import config from '../../config'
import getters from '../getters/clientGetter'
import actions from '../actions/clientAction'
import mutations from '../mutations/clientMutation'
import {getUrlParam, getSessionCache} from '../../utils/'

const state = {
  // 客户端数据
  client: {
    env: '',
    clientVersionId: config.clientVersionId,
    channelId: config.channelId,
    clientVersionNo: config.clientVersionNo
  },
  // 用户数据
  user: {
    token: '',
    sharMode: '',
    userID: config.userId,
    // 微信用户id
    unionId: getUrlParam('unionId') || getSessionCache('unionId'),
    appId: getUrlParam('appId') || getSessionCache('appId'),
    openId: getUrlParam('openId') || getSessionCache('openId'),
    // 邀请码
    inviteCode: ''
    // 营销系统要的邀请人信息
    , cyAuthToken: ''
    , cyAuthType: ''
    , cyUserId: ''
  }
}

export default {
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
}
